module.exports = __webpack_public_path__ + "static/media/demo.af289062.xlsx";